import React from 'react'

const FranchiseSinglepage = () => {
    return (
        <div>
            franchisesinglepage
        </div>
    )
}

export default FranchiseSinglepage
